import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { z } from "zod";

import Container from "@/components/containers/Container";
import type { ChildRouteContext } from "@/root";

import ObjectiveForm from "@/modules/performance/user/components/objective/form/ObjectiveForm";

export const Route = createFileRoute(
  "/_panel/_performance/performance/objectives/create",
)({
  component: RouteComponent,
  validateSearch: z.object({
    parent_id: z.coerce.number().optional(),
  }),
  beforeLoad: ({ context }) =>
    ({
      crumb: [
        {
          label: context.t("Create New Objective", { ns: "performance.user" }),
        },
      ],
    }) satisfies ChildRouteContext,
});

function RouteComponent() {
  const { t } = useTranslation("performance.user");
  const { parent_id: parentId } = Route.useSearch();

  return (
    <Container
      title={t("Create New Objective")}
      description={t(
        "For creating advanced objectives, please refer to the objectives section.",
      )}
      className="flex h-full flex-col"
    >
      <ObjectiveForm parentId={parentId} />
    </Container>
  );
}
